import React from 'react';
import { IonContent, IonPage, IonRefresher, IonRefresherContent } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { AppHeader, StoreFilterBar, PeriodTabs } from '../../components';
import { formatLastRefreshed } from '../../utils/lastRefreshed';
import './home.css';

export interface SuScreenProps {
  storeCount?: number | null;
  onRefresh: () => void;
  error?: Error | null;
  hasData: boolean;
  /** API `as_of`; shown under the title as "Last refreshed: HH:MM (GMT +5:30)". */
  asOf?: string | null;
  children: React.ReactNode;
}

/** Shared scaffold for Home / Network: header, filter bar, period tabs, pull-to-refresh, error state. */
const SuScreen: React.FC<SuScreenProps> = ({ storeCount, onRefresh, error, hasData, asOf, children }) => {
  const history = useHistory();
  return (
    <IonPage>
      <AppHeader subtitle={formatLastRefreshed(asOf)} onSearch={() => history.push('/app/stores?focus=search')} />
      <IonContent>
        <IonRefresher
          slot="fixed"
          onIonRefresh={(e) => {
            onRefresh();
            setTimeout(() => e.detail.complete(), 600);
          }}
        >
          <IonRefresherContent />
        </IonRefresher>
        <div className="su-page" style={{ paddingTop: 0 }}>
          <StoreFilterBar count={storeCount} />
          <PeriodTabs />
          {error && !hasData ? (
            <div className="su-card su-home-error" role="alert">
              <span>Couldn't load sales data.</span>
              <button type="button" className="su-home-retry" onClick={onRefresh}>Retry</button>
            </div>
          ) : (
            children
          )}
        </div>
      </IonContent>
    </IonPage>
  );
};

export default SuScreen;
